<wlm-popup-wrapper
  [titleKey]="titleKey"
  [showCloseButton]="true"
  [actionsContainerClass]="'worpskace-form-actions-container'"
  (popupClose)="cancel($event)"
>
  <ng-container popup-content>
    <div class="connect-form-container">
      <div class="connect-form-margin"></div>
      <tc-master-operator-connect
        class="connect-form-content"
        (configured)="onConfigured($event)"
        (validChanged)="onValidChanged($event)"
        [masterInstanceIds]="masterInstanceIds"
        [settings]="settings"
        [showTitle]="false"
      ></tc-master-operator-connect>
      <div class="connect-form-margin"></div>
    </div>
  </ng-container>
  <ng-container popup-actions>
    <button
      mat-raised-button
      class="wtr-action-button-primary"
      onclick="this.blur()"
      (click)="connect()"
      [disabled]="!isValid"
    >
      {{ T_SCOPE + '.buttons.connect' | translate }}
    </button>
  </ng-container>
</wlm-popup-wrapper>
